import { Typography } from '@mui/material';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { LwBlockGridContainer } from 'redesign';
import { ServiceAgreementBlock } from '../components/service-agreement-block';

export const useGetCollegialLendingScreenTabs = (data: ServiceAgreementsResponse) => {
  const { t } = useTranslation('all-platforms-common');

  const lenderAgreements = data.filter(
    (agreement) => agreement.serviceAgreementPartyRole === 'LENDER'
  );
  const borrowerAgreements = data.filter(
    (agreement) => agreement.serviceAgreementPartyRole === 'BORROWER'
  );
  return [
    {
      id: 'service-agreement-lenders',
      tabLabel: t('service-agreement.lender'),
      element: <ServiceAgreementList data={lenderAgreements} />,
    },
    {
      id: 'service-agreement-borrowers',
      tabLabel: t('service-agreement.borrower'),
      element: <ServiceAgreementList data={borrowerAgreements} />,
    },
  ];
};

const ServiceAgreementList = ({ data }: { data: ServiceAgreementsResponse }) => {
  const { t } = useTranslation('ogp-screen-specific');
  return (
    <>
      {data.length === 0 ? (
        <Typography>{t('collegial_lending_page.no_service_agreements')}</Typography>
      ) : (
        <LwBlockGridContainer container spacing={4}>
          {data.map((item, index) => (
            <ServiceAgreementBlock key={index} serviceAgreement={item} />
          ))}
        </LwBlockGridContainer>
      )}
    </>
  );
};
